import { Component, EventEmitter, Input, Output } from '@angular/core'
import { trigger, transition, style, animate } from '@angular/animations'

@Component({
  selector: 'app-system-notification',
  // standalone: true,
  // imports: [],
  templateUrl: './system-notification.component.html',
  styleUrl: './system-notification.component.scss',
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ]

})
export class SystemNotificationComponent {
  /** Required content */
  @Input() title!: string
  @Input() message!: string

  /** CTA */
  @Input() actionLabel?: string
  @Output() action = new EventEmitter<void>()

  /** Visibility */
  @Input() visible: boolean = false

  close() {
    this.visible = false
  }

  onAction() {
    this.action.emit()
  }
}
